import { format } from 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { REACT_APP_VAM_CONTEXT_DOCUMENT, REACT_APP_VAM_ENDPOINT } from '../urls';
import { documentsListsForUpload, editModeOn, filterLetters, getFromDecreaptLocalStorage, scrollToTop, viewModeOn } from '../utilFunctions';
import NoDataFound from '../utilsComponent/noDataFound';
import LoadingPage from '../reusableComponents/loader/loadingPage';
import { functionalities, imageVideoAndPdfExtensions, KISAN_SATHI } from '../consts';
import { axiosRequest } from '../service';
import DocumentSliderModal from '../utilsComponent/DocumentSliderModal';
import { getClaimDocuments, startClaimIntimationImageCoordinatesService } from './apiHelper';
import TabComponent from '../reusableComponents/tab/TabComponent';
import PolicyDocumentsSection from './documentsIAGRI/PolicyDocumentsSection';
import { loadPolicyDocumentsData } from './documentsIAGRI/documentFetchHelpers'
import { useLocation } from 'react-router-dom';
import { loadPolicyDocuments } from './documentsIAGRI/apiHelper';

const Documents = (props) => {

    const location = useLocation();
    const { policyDetailCookie } = props;
    const [showRequestedDocs, setShowRequestedDocs] = useState(false);
    const [showUploadedDocs, setShowUploadedDocs] = useState(true);
    const [othersChecked, setOthersChecked] = useState(false);
    const [othersText, setOthersText] = useState('');
    const [file, setFile] = useState([]);
    const [dragActive, setDragActive] = useState(false);
    const [isFileLoading, setIsFileLoading] = useState(false)
    const [selectedDocument, setSelectedDocument] = useState("")
    const [addedFiles, setAddedFiles] = useState([])
    const [fileSize, setfileSize] = useState(0);
    const roleDataCookie = getFromDecreaptLocalStorage("roleData")
    const claimDetailCookie = getFromDecreaptLocalStorage("claimDetail")
    const [formDataForAPi, setFormDataForAPi] = useState(null)
    const [fileInputAPi, setFileInputApi] = useState(null)
    const [uploadedDocumentsList, setUploadedDocumentsList] = useState([])
    const formData = new FormData();
    const [showSliderModal,setShowSliderModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(false);
    const ignoreFileKeys = ['PreRegRuleLog', 'PostRegRuleLog','Rejection Letter','CWP Letter', 'Rejection Letter', 'Payout Letter', 'rejection', 'repudiation', 'payment']; // there are system generated json files
    const [activeTab, setActiveTab] = useState(() => {
    return location.state?.activeTab || 'documents'; // Default to 'documents'
  });
        // New state for Policy Documents
    const [policyDocuments, setPolicyDocuments] = useState([]);
    const [isLoadingPolicyDocuments, setIsLoadingPolicyDocuments] = useState(false);
    const [showPolicyDocSliderModal, setShowPolicyDocSliderModal] = useState(false);
    const [currentPolicyDocSlideIndex, setCurrentPolicyDocSliderIndex] = useState(0);
    
    useEffect(() => {
        if (activeTab === 'policyDocuments') {
            scrollToTop();
        }
    }, [activeTab]);

    // This useEffect will only run when the activeTab changes to 'policyDocuments'
    // and the policy documents haven't been fetched yet.
    useEffect(() => {
        if (policyDetailCookie) {
            // The isLoading state is now managed entirely within the loadPolicyDocumentsData function
            // and doesn't need to be in the dependency array.
            if(policyDetailCookie?.policy_number?.includes("/")) {
                loadPolicyDocuments(policyDetailCookie, setIsLoadingPolicyDocuments, setPolicyDocuments)
            } else {
                loadPolicyDocumentsData(policyDetailCookie, setIsLoadingPolicyDocuments, setPolicyDocuments)
            }
            
        }
    }, [policyDetailCookie]);

    // Function to open the slider for policy documents
    const openPolicyDocSlider = useCallback((index) => {
        setCurrentPolicyDocSliderIndex(index);
        setShowPolicyDocSliderModal(true);
    }, []);

    // Memoize the getUploadedDocumentsList function using useCallback
    const getUploadedDocumentsList = useCallback(async () => {
        const data = await getClaimDocuments(claimDetailCookie.claimNo);
        if (data?.data) {
            setUploadedDocumentsList(filterLetters(data.data, false))
        }
        return data?.data
    }, [claimDetailCookie.claimNo]);

    // This useEffect will only run on mount and when claimNo changes.
    // It handles fetching uploaded documents.
    useEffect(() => {
        getUploadedDocumentsList();
    }, [getUploadedDocumentsList]);

    

    // Handles the deletion of a file from the list of files.
    const handleDeleteFile = (index) => {
        const updatedFiles = [...file];
        // Removes selected file from the list 
        updatedFiles.splice(index, 1);
        setFile(updatedFiles);
        let newFileSize = 0;
        let formData = new FormData();
        // Calculate the size of each file in megabytes (MB) and add it to the total file size.
        updatedFiles.forEach(file => {
            const fileSizeMB = Number((file.size / (1024 * 1024)).toFixed(4));
            newFileSize += fileSizeMB;
            formData.append('files', file);
        });
        setfileSize(newFileSize);
        setFormDataForAPi(formData);
        setAddedFiles(updatedFiles.map(file => ({ name: file.name })));
    };
    const handleRejectClick = () => {
        setFile([])
        setShowRejectPopover(!showRejectPopover);
    };

    const [showRejectPopover, setShowRejectPopover] = useState(false);
    const handleOthersChange = (event) => {   
        setOthersChecked(event.target.checked);
        if (!event.target.checked) {
            setOthersText('');
        }
    };
   
    const handleDragEnter = () => {
        setDragActive(true);
    };
 
    const handleDragLeave = () => {
        setDragActive(false);
    };
 
    const handleDragOver = (event) => {
        event.preventDefault();
    };
 
    const handleDrop = (event) => {
        event.preventDefault();
        setDragActive(false);
        const fileData = event.dataTransfer.files[0];
        file.push(fileData)
        setFile([...file]);
    };
 
    const handleFileChange = (event) => {
        if (isFileLoading) {
            return
        }
        const fileInput = document.getElementById('fileInput');
        setFileInputApi(fileInput)
        if (!fileInput) {
            setIsFileLoading(false);
            return;
        }
        const newFiles = Array.from(fileInput.files);
        const updatedFiles = [...file, ...newFiles];
        setFile(updatedFiles);
        let newFileSize = fileSize;
        // Ensure formDataForAPi is initialized
        let formData = formDataForAPi || new FormData();

        for (let i = 0; i < newFiles.length; i++) {
            const fileType = newFiles[i].type;
            const fileSizeMB = Number((newFiles[i].size / (1024 * 1024)).toFixed(4));

            if ((fileSizeMB + newFileSize) > 50) {
                toast.error("File Size Should be Less Than 50MB.");
                return;
            }
            if (['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'application/pdf'].includes(fileType)) {
                newFileSize += fileSizeMB;
                formData.append('files', newFiles[i]);
                setAddedFiles(prevFiles => [...prevFiles, { name: newFiles[i].name }]);
            } else {
                toast.error("File should be in the selected format.")
                setIsFileLoading(false)
                fileInput.value = ""; // Clear the file input
                return
            }
        }

        setfileSize(newFileSize);
        setFormDataForAPi(formData);
        setIsFileLoading(false);
    }
 
    const handleSubmit = () => {
        if(!selectedDocument){
            toast.error("Please Select Document Name.")
            return
        }
        if(addedFiles.length === 0){
            toast.error("Please Select Document.")
            return
        } 
        const prevDocuments=uploadedDocumentsList
        setIsFileLoading(true);
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}/cp/upload/bulk?userId=${String(roleDataCookie?.userID)}&docName=${selectedDocument}&claimNo=${claimDetailCookie.claimNo}&source=CMS`, formDataForAPi).then(async data => {
            // setAddedFiles(prevFiles => [...prevFiles, { name: file.name, id: data.data, size: Number(file.size) }]);
            toast.success(data.data)
            setIsFileLoading(false);
            setFile([]);
        setfileSize(0);
        setFormDataForAPi(null);
        setAddedFiles([]);
           const updatedList = await getUploadedDocumentsList()
            const recentlyAddedDocuments = updatedList?.filter(data =>
                prevDocuments.every(item => data.docID !== item.docID)
            ).filter((item)=>!ignoreFileKeys.includes(item.docType)).map(item => item.docName);
        await startClaimIntimationImageCoordinatesService(claimDetailCookie?.claimNo,recentlyAddedDocuments);
        }).catch(error => {
            console.error(error)
            toast.error("Something Went Wrong. ")
        }).finally(() => {            

            setIsFileLoading(false);
            fileInputAPi.value = ""; // Clear the file input
            setFileInputApi(null)
            setSelectedDocument("")
            handleRejectClick()
        });
    };
 
    const requestedDocuments = [
        { siNo: 1, docName: "Aadhar Card", requestedDate: "1-Jan-23", receivedDate: "1-Jan-23" },
        { siNo: 2, docName: "Land Record", requestedDate: "1-Jan-23", receivedDate: "1-Jan-23" },
    ];

    const onDocUrlClick = (index) => {
            setShowSliderModal(true);
            setCurrentIndex(index)
    }
    
    const tabs = [
        { key: 'documents', label: 'Documents', page: functionalities.DOCUMENTS_PAGE },
        { key: 'policyDocuments', label: 'Policy Documents', page: functionalities.DOCUMENTS_PAGE },
    ];

    const filteredTabs = tabs.filter(tab => viewModeOn(tab.page));

    const handleTabClick = (tabKey) => {
        setActiveTab(tabKey);
    };

    return (
    <div className='inner-box2Field  mt-3'>
        <div className='d-flex w-50'>
            <TabComponent
                tabs={filteredTabs}
                activeTab={activeTab}
                handleTabClick={handleTabClick}
            />
        </div>
        {/* <div className='d-flex w-50'>
                <button className={'btn btn-success mt-4 mb-4 px-4 ms-4'} onClick={handleRequestedDocsClick} >Requested Documents</button>
                <button className={'btn btn-success mt-4 mb-4 px-4 ms-5'} onClick={() => handleUploadedDocsClick()} style={{ marginRight: '3%' }}>Uploaded Documents</button>
            </div> */} 
        <div className='d-flex flex-column'>
            {activeTab === 'documents' && (
                <>
                    {/* Requested Documents Block */}
                    {showRequestedDocs && (
                        <>
                            <div className='d-flex justify-content-end w-60'>
                                <button className={'btn btn-outline-success mt-4 mb-4 px-4'} onClick={() => setShowRejectPopover(!showRejectPopover)} style={{ marginRight: '2%' }}>Request For Documents</button>
                                <Modal show={showRejectPopover} isOpen={showRejectPopover} toggle={handleRejectClick} centered={true} backdrop={'static'}>
                                    <ModalHeader>
                                        <h5 className="modal-title" id='requestdocumentformmodal'>Request Documents</h5>
                                        <button type="button" className="btn-close" aria-label="Close" onClick={() => { handleRejectClick(false) }}></button>
                                    </ModalHeader>
                                    <ModalBody>
                                        <div>
                                            <label><h6>Contact Number</h6>
                                                <div>
                                                    <input type="checkbox" id="registered" name="contact" value="7989543606" />
                                                    <label htmlFor="registered">Registered Number - 7989543606</label>
                                                </div>
                                                <div>
                                                    <input type="checkbox" id="alternate" name="contact" value="9876543210" />
                                                    <label htmlFor="alternate">Alternative Number - 9876543210</label>
                                                </div>
                                            </label>
                                        </div>
                                        <label><h6>Required Documents<text style={{ color: 'red' }}>*</text></h6></label>
                                        <div style={{ borderStyle: 'solid', borderWidth: 1, height: "70%", padding: "10px" }}>
                                            {[
                                                "Entire field image",
                                                "Affected Area of field image",
                                                "Affected Area image with 2 meters away",
                                                "Close up image of affected area",
                                                "Image with farmer inside field",
                                                "Farmer Aadhar Card image",
                                                "Claim Survey form image",
                                                "Farmer bank passbook image",
                                                "Farmer land record image",
                                                "Others"
                                            ].map((doc, index) => (
                                                <div key={index}>
                                                    <input type="checkbox" id={`doc-${index}`} onChange={doc === "Others" ? handleOthersChange : null} />
                                                    <label htmlFor={`doc-${index}`}>{doc}</label>
                                                </div>
                                            ))}
                                            {othersChecked && (
                                                <div>
                                                    <input
                                                        type="text"
                                                        value={othersText}
                                                        onChange={(e) => setOthersText(e.target.value)}
                                                        placeholder="Please specify"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </ModalBody>
                                    <ModalFooter style={{ justifyContent: 'center' }}>
                                        <Button color="secondary" style={{ borderColor: 'red', backgroundColor: 'transparent', color: 'red' }} onClick={handleRejectClick}>Cancel</Button>
                                        <Button color="primary" style={{ borderColor: 'green', backgroundColor: 'transparent', color: 'green' }}>Submit</Button>
                                    </ModalFooter>
                                </Modal>
                            </div>
                            <table style={{ border: '1px solid black', marginLeft: '2%', width: '60%', marginBottom: '2%' }}>
                                <thead>
                                    <tr style={{ border: '1px solid black', backgroundColor: 'lightgray' }}>
                                        <th style={{ border: '1px solid black' }}>SI No.</th>
                                        <th style={{ border: '1px solid black' }}>Document Name</th>
                                        <th style={{ border: '1px solid black' }}>Requested Date</th>
                                        <th style={{ border: '1px solid black' }}>Received Date</th>
                                        <th style={{ border: '1px solid black' }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {requestedDocuments.map(doc => (
                                        <tr key={doc.siNo} style={{ border: '1px solid black' }}>
                                            <td style={{ border: '1px solid black' }}>{doc.siNo}</td>
                                            <td style={{ border: '1px solid black' }}>{doc.docName}</td>
                                            <td style={{ border: '1px solid black' }}>{doc.requestedDate}</td>
                                            <td style={{ border: '1px solid black' }}>{doc.receivedDate}</td>
                                            <td style={{ border: '1px solid black' }}><button className="btn btn-link">View</button></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )}
                    {/* Uploaded Documents Block */}
                    {showUploadedDocs && (
                        <>
                            <div className='d-flex justify-content-end w-60'>
                                {editModeOn(functionalities.DOCUMENTS_UPLOAD) && <button className={'btn btn-success mt-4 mb-4 px-4'} onClick={() => { setAddedFiles([]); setSelectedDocument(""); setShowRejectPopover(!showRejectPopover) }} style={{ marginRight: '2%' }}>Upload</button>}
                                <Modal show={showRejectPopover} isOpen={showRejectPopover} toggle={handleRejectClick} centered={true} backdrop={'static'}>
                                    <ModalHeader>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleRejectClick} ></button>
                                    </ModalHeader>
                                    <ModalBody>
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group mb-3">
                                                <label htmlFor="articalmemorandum">Select Document Name <span style={{ color: 'red' }}>*</span></label>
                                                <Select
                                                    id="exampleInputPassword1"
                                                    options={documentsListsForUpload()}
                                                    placeholder="Select Document Name"
                                                    value={selectedDocument ? { label: selectedDocument } : "Select Document Name"}
                                                    onChange={(data) => { setSelectedDocument(data.value); }}
                                                />
                                                <label htmlFor="fileInput" className='mt-3'>Upload Documents <span style={{ color: 'red' }}>*</span></label>
                                                <div
                                                    className="drop-zone"
                                                    onDragEnter={handleDragEnter}
                                                    onDragOver={handleDragOver}
                                                    onDragLeave={handleDragLeave}
                                                    onDrop={handleDrop}
                                                    style={{
                                                        border: '4px dashed #ccc',
                                                        borderRadius: '5px',
                                                        padding: '25px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    {isFileLoading ? (
                                                        <LoadingPage />
                                                    ) : (
                                                        <>
                                                            <label htmlFor="fileInput" className="drop-zone__prompt pointer">Drop file here or click to upload</label>
                                                            <input
                                                                type="file"
                                                                name="fileInput"
                                                                id="fileInput"
                                                                className="drop-zone__input"
                                                                accept=".pdf, .jpg, .jpeg, .png, .gif"
                                                                onChange={() => handleFileChange()}
                                                                onClick={(event) => event.target.value = ""}
                                                                style={{ display: 'none' }}
                                                                multiple
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                                {addedFiles.map((file, index) => (
                                                    <div className="align_4_dataPolicy deletePolicy mt-2" key={file.id}>
                                                        <span className="hoverPolicy" style={{ wordBreak: "break-all", wordWrap: "auto" }}>{file.name}</span>
                                                        <span className="marginPolicy hoverPolicy" onClick={() => { handleDeleteFile(index) }}>
                                                            <img
                                                                src="/kshemaImages/delete_symbol.png"
                                                                alt="delete"
                                                                height="18px"
                                                                width="auto"
                                                            />
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </form>
                                    </ModalBody>
                                    <ModalFooter style={{ justifyContent: 'center' }}>
                                        <Button color="secondary" style={{ borderColor: 'red', backgroundColor: 'transparent', color: 'red' }} onClick={handleRejectClick}>Cancel</Button>
                                        <Button color="primary" style={{ borderColor: 'green', backgroundColor: 'transparent', color: 'green' }} onClick={() => handleSubmit()}>Submit</Button>
                                    </ModalFooter>
                                </Modal>
                            </div>
                            {uploadedDocumentsList && uploadedDocumentsList.length > 0 ? (
                                <div style={{ height: '500px', overflowY: 'scroll' }}>
                                    <table style={{ marginLeft: '2%', border: '1px solid black', width: '97%', marginBottom: '2%' }}>
                                        <thead>
                                            <tr style={{ border: '1px solid black', backgroundColor: 'lightgray' }}>
                                                <th style={{ border: '1px solid black' }}>S.No</th>
                                                <th style={{ border: '1px solid black' }}>Uploaded Date</th>
                                                <th style={{ border: '1px solid black' }}>Uploaded By</th>
                                                <th style={{ border: '1px solid black' }}>Documents</th>
                                                <th style={{ border: '1px solid black' }}>Source</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {uploadedDocumentsList.map((doc, index) => (
                                                <tr key={index} style={{ border: '1px solid black' }}>
                                                    <td style={{ border: '1px solid black' }}>{index + 1}</td>
                                                    <td style={{ border: '1px solid black' }}>{doc.createdDate ? format(new Date(doc.createdDate.split(".")[0]), 'dd-MM-yyyy, hh:mm a') : "-"}</td>
                                                    <td style={{ border: '1px solid black' }}>{doc.createdBy || "-"}</td>
                                                    <td onClick={() => { onDocUrlClick(index) }} className='pointer text-primary' style={{ border: '1px solid black' }}>{doc.docName}</td>
                                                    <td style={{ border: '1px solid black' }}>{doc.source || "-"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : <NoDataFound text="No Data Found" />}
                        </>
                    )}
                </>
            )}
            {showSliderModal && (
                <DocumentSliderModal
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    onClose={() => { setShowSliderModal(false) }}
                    documents={uploadedDocumentsList}
                    show={showSliderModal}
                />
            )}
            {activeTab === 'policyDocuments' && (
                <PolicyDocumentsSection
                    documents={policyDocuments}
                    isLoadingDocuments={isLoadingPolicyDocuments}
                    openDocumentSlider={openPolicyDocSlider}
                    isSliderOpen={showPolicyDocSliderModal}
                    currentSlideIndex={currentPolicyDocSlideIndex}
                    setCurrentSlideIndex={setCurrentPolicyDocSliderIndex}
                    onSliderClose={() => setShowPolicyDocSliderModal(false)}
                />
            )}
        </div>
    </div>
 )
}
export default Documents;